import {
    FINANCIAL_DOCUMENT_PAYMENT_STATUS,
    FINANCIAL_DOCUMENT_STATUS,
    FINANCIAL_DOCUMENT_TYPE,
} from 'src/features/financialDocuments/utils/types';
import { financialDocumentsMessages } from 'src/features/financialDocuments/utils/messages';
import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { paymentsMessages } from 'src/features/payments/utils/messages';

export const FINANCIAL_DOCUMENT_TYPE_TRANSLATIONS: Record<
    FINANCIAL_DOCUMENT_TYPE,
    { id: string; defaultMessage: string }
> = {
    [FINANCIAL_DOCUMENT_TYPE.INVOICE]: financialDocumentsMessages.invoice,
    [FINANCIAL_DOCUMENT_TYPE.PROFORMA]: financialDocumentsMessages.proforma,
    [FINANCIAL_DOCUMENT_TYPE.RECEIPT]: financialDocumentsMessages.receipt,
    [FINANCIAL_DOCUMENT_TYPE.CREDIT_NOTE]: financialDocumentsMessages.creditNote,
    [FINANCIAL_DOCUMENT_TYPE.DEBIT_NOTE]: financialDocumentsMessages.debitNote,
};

export const FINANCIAL_DOCUMENT_TYPE_BADGE_OPTIONS: Record<FINANCIAL_DOCUMENT_TYPE, BadgeOption> = {
    [FINANCIAL_DOCUMENT_TYPE.INVOICE]: {
        label: financialDocumentsMessages.invoice,
        icon: ICON_MAP.INVOICE,
        theme: 'green',
    },
    [FINANCIAL_DOCUMENT_TYPE.PROFORMA]: {
        label: financialDocumentsMessages.proforma,
        icon: ICON_MAP.INVOICE,
        theme: 'gray',
    },
    [FINANCIAL_DOCUMENT_TYPE.RECEIPT]: {
        label: financialDocumentsMessages.receipt,
        icon: ICON_MAP.RECEIPT,
        theme: 'blue',
    },
    [FINANCIAL_DOCUMENT_TYPE.CREDIT_NOTE]: {
        label: financialDocumentsMessages.creditNote,
        icon: ICON_MAP.MINUS_CIRCLE,
        theme: 'red',
    },
    [FINANCIAL_DOCUMENT_TYPE.DEBIT_NOTE]: {
        label: financialDocumentsMessages.debitNote,
        icon: ICON_MAP.PLUS_CIRCLE,
        theme: 'orange',
    },
};

export const FINANCIAL_DOCUMENT_STATUS_BADGE_OPTIONS: Record<FINANCIAL_DOCUMENT_STATUS, BadgeOption> = {
    [FINANCIAL_DOCUMENT_STATUS.DRAFT]: {
        label: financialDocumentsMessages.draft,
        icon: ICON_MAP.FROZEN,
        theme: 'gray',
    },
    [FINANCIAL_DOCUMENT_STATUS.ISSUED]: {
        label: financialDocumentsMessages.issued,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [FINANCIAL_DOCUMENT_STATUS.VOIDED]: {
        label: financialDocumentsMessages.voided,
        icon: ICON_MAP.X_MARK,
        theme: 'red',
    },
};

export const FINANCIAL_DOCUMENT_PAYMENT_STATUS_BADGE_OPTIONS: Record<FINANCIAL_DOCUMENT_PAYMENT_STATUS, BadgeOption> = {
    [FINANCIAL_DOCUMENT_PAYMENT_STATUS.PAID]: {
        label: paymentsMessages.paid,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [FINANCIAL_DOCUMENT_PAYMENT_STATUS.PARTIAL]: {
        label: paymentsMessages.paymentStatusPartial,
        icon: ICON_MAP.CHECK,
        theme: 'orange',
    },
    [FINANCIAL_DOCUMENT_PAYMENT_STATUS.NONE]: {
        label: paymentsMessages.paymentStatusNone,
        icon: ICON_MAP.FROZEN,
        theme: 'gray',
    },
};
